import axios from "axios";
import { baseURL } from "../../../utils/api";

function createAxios() {
  const token = JSON.parse(localStorage.getItem("profile"))?.token;
  return axios.create({
    baseURL: `${baseURL}/payout`,
    headers: {
      "content-type": "application/json",
      authorization: `Bearer ${token && token.access}`,
    },
  });
}

export const requestPayout = async (payload) => {
  try {
    let API = createAxios();
    const { data } = await API.post("/requestPayout", payload);
    return data;
  } catch (e) {
    console.error("requestPayout error:", e);
    return { success: false, message: e.message };
  }
};

export const getAllPayouts = async (payload) => {
  try {
    let API = createAxios();
    const { data } = await API.get("/getAllPayouts");
    return data;
  } catch (e) {
    console.error("getAllPayouts error:", e);
    return { success: false, data: [] };
  }
};

export const updatePayoutById = async (id, payload) => {
  try {
    let API = createAxios();
    const { data } = await API.patch(`/${id}`, payload);
    return data;
  } catch (e) {
    console.error("updatePayoutById error:", e);
    return { success: false, message: e.message };
  }
};

export const sendEmailToTeacher = async (payload) => {
  try {
    let API = createAxios();

    await API.post("/sendEmail", payload);


    // return data;
  } catch (e) {
    console.error(e);
  }
};
